import { useGetCredits } from './use-get-credits';

export const useCreditsTotalPage = () => {
  const creditsQuery = useGetCredits();

  return creditsQuery?.data?.pagination.totalPages ?? 0;
};
